// Brands tab of a brand group: the All / Current / Past pills above the ledger.
//
// Delegated, because the component loads into its Turbo Frame after document ready - a direct bind
// would run before these pills exist.
$(document).on('click', '.brand-groups-brand-ledger-component .ledger-filter', function () {
  const $filter = $(this);
  const $component = $filter.closest('.brand-groups-brand-ledger-component');
  const status = $filter.data('status');

  $component.find('.ledger-filter').removeClass('active');
  $filter.addClass('active');

  $component.find('.ledger-rows tbody tr').each(function () {
    const $row = $(this);
    $row.toggle(status === 'all' || $row.data('status') === status);
  });
});
